module.exports = __webpack_public_path__ + "static/img/no_honour_activity.46ea761e.png";